import React from 'react'
import TodayTasks from "./TodayTasks"

const CompletedTasks = () => {
  return (
    <div>
      <TodayTasks />
    </div>
  )
}

export default CompletedTasks
